interface Data {
  handle: string;
  id: number;
}

export default class BrowserApi {
  LOCAL_STORAGE_KEY = 'wishlist_handles';

  list: Array<string>;

  constructor() {
    const storedHandles = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    this.list = JSON.parse(storedHandles ?? '[]');
  }

  saveList() {
    localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(this.list));
  }

  hasItem(data: Data) {
    return this.list.includes(data.handle);
  }

  addItem(data: Data) {
    this.list.push(data.handle);
    this.saveList();
  }

  removeItem(data: Data) {
    this.list = this.list.filter((handle) => handle !== data.handle);
    this.saveList();
  }

  toggleItem(data: Data) {
    return this.hasItem(data) ? this.removeItem(data) : this.addItem(data);
  }

  clearItems() {
    this.list = [];
    this.saveList();
  }

  getItems() {
    return this.list;
  }
}
